import{jsx as r,Fragment as t}from"react/jsx-runtime";import i from"./tag.js";const o=({scripts:o})=>r(t,{children:Array.isArray(o)&&o.filter((r=>"body"===r.location)).map(((t,o)=>r(i,{scriptTag:t},o)))});export{o as ScriptGenerator};
